
































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'

@Component
export default class ModalAddTabelaPrestador extends Vue {
  camposCadastrais: boolean = false

  $refs!: {
    formPrestador: any,
    imageUpload: any,
  }

  form: any = {
    valid: true,
    prestador: [(v: any) => !!v || 'Campo obrigatório'],
  }

  loadSaveAddGestor: boolean = false
  get loadingSaveAddGestor() { return this.loadSaveAddGestor }
  set loadingSaveAddGestor(value: boolean) { this.loadSaveAddGestor = value }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get showModalAddTabelaPrestadores() { return this.getRecebimentoStore.modalAddTabelaPrestador }
  set showModalAddTabelaPrestadores(value: boolean) { this.getRecebimentoStore.setModalAddTabelaPrestador(value) }

  get prestadores() { return this.getRecebimentoStore.prestadores }

  get selectedPrestador() { return this.getRecebimentoStore.selectedPrestador }
  set selectedPrestador(value: any) { this.getRecebimentoStore.setSelectedPrestador(value) }

  async saveAddPrestador() {
    this.loadingSaveAddGestor = true
    if (!(await this.$refs.formPrestador.validate())) {
      this.loadingSaveAddGestor = false
      return
    }
    const response = await this.getRecebimentoStore.upsertTabelaPrestadores()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Prestador adicionado com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getRecebimentoStore.getTabelaPrestadores(this.getRecebimentoStore.tabelaPrecoId)
      this.showModalAddTabelaPrestadores = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao adicionar prestador!', icon: 'warning', color: '#C62828' })
    }
    this.loadingSaveAddGestor = false
  }

  @Watch('showModalAddTabelaPrestadores')
  onChangeShowModalEditarHospital(value: boolean) {
    if (!value) {
      this.$refs.formPrestador.resetValidation()
      this.$refs.formPrestador.reset()
    }
  }
}
